import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/stores/auth.store'

const IDLE_MS = 10 * 60 * 1000 // 10 dakika

const ACTIVITY_EVENTS = [
  'mousemove', 'mousedown', 'keydown',
  'touchstart', 'scroll', 'click', 'wheel',
]

export function useIdleLogout() {
  const { isAuthenticated, logout } = useAuthStore()
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (!isAuthenticated) return

    function resetTimer() {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        logout()
        window.location.href = '/login'
      }, IDLE_MS)
    }

    // İlk sayfa yükünde timer'ı başlat
    resetTimer()

    // Kullanıcı aktivitelerinde timer'ı sıfırla
    ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, resetTimer, { passive: true }))

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
      ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, resetTimer))
    }
  }, [isAuthenticated, logout])
}
